import { Component, SimpleChanges } from '@angular/core';
import { DataSharingService } from '../../services/data-sharing/data-sharing.service';
import { SelectChangeEventDetail } from '@ionic/angular';

@Component({
  selector: 'app-ride-schutz-leistung',
  templateUrl: './ride-schutz-leistung.component.html',
  styleUrls: ['./ride-schutz-leistung.component.scss'],
})
export class RIDESchutzLeistungComponent {
  inspOptionsExtended = [
    { value: 2, display: 'Flex' },
    { value: 1, display: 'Basis' },
  ];
  inspOptions = [
    { value: 1, display: 'Mit Inspektion' },
    { value: 0, display: 'Ohne Inspektion' },
  ];
  public JaNeinList = [
    { value: false, display: 'Nein' },
    { value: true, display: 'Ja' },
  ];
  isDisbeld = false;
  private dsCodeChanged = '';

  constructor(public dSS: DataSharingService) {}

  update(changes: any): void {
    this.dSS.inputChanged.next(true);
  }

  // updateRadFahrSchutz(changes: SimpleChanges): void{
  //  if (changes.RadFahrSchutz){
  // }
  // this.dSS.inputChanged.next(true);
  // }

  checkInspektion() {
    if (this.dsCodeChanged === this.dSS.dsCode) {
      return;
    }
    this.dsCodeChanged = this.dSS.dsCode;

    this.isDisbeld =
      this.dSS.dienststelle.inspektion !== 0 && this.dSS.dsCode !== '';
  }
  // also maybe use a Pipe or use a better approach
  getInspectionOption() {
    return this.dSS.isVivantes() ? this.inspOptionsExtended : this.inspOptions;
  }
}
